import React from 'react';
import milaBox from 'assets/images/mila-box.png';
import milaBoxWebp from 'assets/images/mila-box.png?as=webp';
import LazyLoad from 'react-lazyload';
import loadable from '@loadable/component';

const FadeIn = loadable(() => import('../common/FadeIn'));

const SbsicBlock = () => (
  <section className='sbsic-block'>
    <div className='container'>
      <div className='sbsic-block__image'>
        <LazyLoad>
          <FadeIn>
            <picture>
              <source srcSet={milaBoxWebp} type='image/webp' />
              <source srcSet={milaBox} type='image/png' />
              <img src={milaBox} alt='mila-box' />
            </picture>
          </FadeIn>
        </LazyLoad>
      </div>
      <div className='sbsic-block__content'>
        <h2 className='sbsic-block__title'>A refreshingly thoughtful air purifier.</h2>
        <div className='sbsic-block__description'>
          <p>
            In building Mila, we did something radical: we thought about people. What would they need and want?
            Throughout our journey of design, engineering, and launching on Kickstarter, we’ve taken countless ideas and
            suggestions on board to create a product that puts people first.
          </p>
          <p>
            Mila is a best-in-class HEPA air purifier that’s better in every way. She’s smart, simple, quiet, and
            affordable (and cute, because our hunch was right: No one wants an eyesore in their living room).
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default SbsicBlock;
